import { observer } from 'mobx-react';
import Select from 'react-select';

const StationSelect = ({ station, stations, onChange, isInvalid }) => {
  const grouped = stations
    .slice()
    .sort((a, b) => (a.DisplayOrder || 0) - (b.DisplayOrder || 0))
    .reduce((acc, s) => {
      const region = s.Region || 'Other';
      if (!acc[region]) acc[region] = [];
      acc[region].push({ label: s.Logger_Name, value: s.Station_ID });
      return acc;
    }, {});

  const options = Object.entries(grouped)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([region, stationOptions]) => ({
      label: region,
      options: stationOptions
    }));

  const selectedStation = stations.find(
    (s) => s.Station_ID === station?.Station_ID
  );
  const selectedValue = selectedStation
    ? { label: selectedStation.Logger_Name, value: selectedStation.Station_ID }
    : null;

  return (
    <Select
      value={selectedValue}
      options={options}
      onChange={onChange}
      placeholder='Select station...'
      styles={{
        control: (base) => ({
          ...base,
          ...(isInvalid && {
            borderColor: '#dc3545',
            '&:hover': { borderColor: '#dc3545' }
          })
        })
      }}
    />
  );
};

export default observer(StationSelect);

